import { render } from "./CaseDetailDialog.vue?vue&type=template&id=ef551402"
import script from "./CaseDetailDialog.vue?vue&type=script&lang=js"
export * from "./CaseDetailDialog.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__